import ToastContainers from "./Utils/ToastContainer";
import PageNotFound404 from "./Errors/PageNotFound404";
import { BrowserRouter, Route, Routes } from "react-router-dom";
import Base from "./Pages/Base";
import './App.css';
import Homepage from "./Pages/Homepage";
import Portfolio from "./Pages/Portfolio";
import PortfolioDetails from "./Pages/PortfolioDetails";
import Blog from "./Pages/Blog";
import BlogDetails from "./Pages/BlogDetails";
import Contact from "./Pages/Contact";
import Team from "./Pages/Team";
import Recognitions from "./Pages/Recognitions";
import Careers from "./Pages/Careers";
import CustomerExperience from "./Pages/Services/CustomerExperience";
import TrainingPrograms from "./Pages/Services/TrainingPrograms";
import BusinessStrategy from "./Pages/Services/BusinessStrategy";
import ESGConsulting from "./Pages/Services/ESGConsulting";
import DevelopmentHub from "./Pages/Services/DevelopmentHub";
import Login from "./Pages/Login";
import RoleSelection from "./Pages/RoleSelection";
import Register from "./Pages/Register";
import SuperAdmin from "./Pages/SuperAdmin";
import CompanyLogin from "./Pages/CompanyLogin";
import CompanyDashboard from "./Pages/CompanyDashboard";
import CompanyDashboardPart2 from "./Pages/CompanyDashboardPart2/CompanyDashboardPart2";
import EnglishCompanyDashboard from "./Pages/EnglishCompanyDashboard/CompanyDashboard";
import AdminLogin from "./Pages/AdminLogin";
import AdminBillManagement from "./Pages/AdminBillManagement";
import AdminFieldDragDrop from "./Pages/AdminFieldDragDrop";
import AdminRozNamachaFields from "./Pages/AdminRozNamachaFields";
import AdminRecoveryManagement from "./Pages/AdminRecoveryManagement";
import AdminExpenseManagement from "./Pages/AdminExpenseManagement";
import AdminPaymentMethods from "./Pages/AdminPaymentMethods";
import AdminTeamMembers from "./Pages/AdminTeamMembers";
import AdminRecognitions from "./Pages/AdminRecognitions";
import AdminBlogs from "./Pages/AdminBlogs";
import AdminBillHeaderImage from "./Pages/AdminBillHeaderImage";
import AdminCompanyDashboardManagement from "./Pages/AdminCompanyDashboardManagement";
import BillView from "./Pages/BillView";
import CreateBill from "./Pages/CreateBill";
import CreateBillPart2 from "./Pages/CompanyDashboardPart2/CreateBillPart2";
// CompanyDashboardPart2 standalone pages with P2 suffix
import BankKhataP2Wrapper from "./Pages/CompanyDashboardPart2/BankKhataP2Wrapper";
import ExpenseLedgerP2Wrapper from "./Pages/CompanyDashboardPart2/ExpenseLedgerP2Wrapper";
import ReceivableKhataP2Wrapper from "./Pages/CompanyDashboardPart2/ReceivableKhataP2Wrapper";
import PayableKhataP2Wrapper from "./Pages/CompanyDashboardPart2/PayableKhataP2Wrapper";
import ProfitLossAccountP2Wrapper from "./Pages/CompanyDashboardPart2/ProfitLossAccountP2Wrapper";
import ReceiptManagementP2Wrapper from "./Pages/CompanyDashboardPart2/ReceiptManagementP2Wrapper";
import CustomerKhataP2Wrapper from "./Pages/CompanyDashboardPart2/CustomerKhataP2Wrapper";
import SupplierKhataP2Wrapper from "./Pages/CompanyDashboardPart2/SupplierKhataP2Wrapper";
import RozNamachaP2Wrapper from "./Pages/CompanyDashboardPart2/RozNamachaP2Wrapper";
import AkhrajatBookP2Wrapper from "./Pages/CompanyDashboardPart2/AkhrajatBookP2Wrapper";
import AmdaniBookP2Wrapper from "./Pages/CompanyDashboardPart2/AmdaniBookP2Wrapper";
import RecoveryDetailsP2Wrapper from "./Pages/CompanyDashboardPart2/RecoveryDetailsP2Wrapper";
import CreateSale from "./Pages/CreateSale";
import SaleView from "./Pages/SaleView";
import CreateRecovery from "./Pages/CreateRecovery";
import RecoveryView from "./Pages/RecoveryView";
import RecoveryRecords from "./Pages/RecoveryRecords";
import GeneralSale from "./Pages/GeneralSale";
import SettledBill from "./Pages/SettledBill";
import RozNamacha from "./Pages/RozNamacha";
import ReceivableKhata from "./Pages/ReceivableKhata";
import PayableKhata from "./Pages/PayableKhata";
import ExpenseFieldsLedger from "./Pages/ExpenseFieldsLedger";
import ProfitLossAccount from "./Pages/ProfitLossAccount";
import BankKhata from "./Pages/BankKhata";
import ExpenseLedger from "./Pages/ExpenseLedger";
import ExpenseFieldsDetails from "./Pages/ExpenseFieldsDetails";
import UserManage from "./Pages/UserManage";
import StockReport from "./Pages/StockReport";


function App() {
  return (
    <>
      <BrowserRouter>

        {/* ToastContainer */}
        <ToastContainers />

        {/* Routes */}
        <Routes>

          {/* Main Routes */}
          <Route path='/' element={<Base><Homepage /></Base>} />
          <Route path='/contact' element={<Base><Contact /></Base>} />
          <Route path='/team' element={<Base><Team /></Base>} />
          <Route path='/about' element={<Base><Recognitions /></Base>} />
          <Route path='/careers' element={<Base><Careers /></Base>} />

          {/* Services Routes */}
          <Route path='/services/customer-experience' element={<Base><CustomerExperience /></Base>} />
          <Route path='/services/training-programs' element={<Base><TrainingPrograms /></Base>} />
          <Route path='/services/business-strategy' element={<Base><BusinessStrategy /></Base>} />
          <Route path='/services/esg-consulting' element={<Base><ESGConsulting /></Base>} />
          <Route path='/services/development-hub' element={<Base><DevelopmentHub /></Base>} />

          {/* Portfolio Routes */}
          <Route path='/portfolio' element={<Base><Portfolio /></Base>} />
          <Route path='/portfolio/:id' element={<Base><PortfolioDetails /></Base>} />

          {/* Blog Routes */}
          <Route path='/blog' element={<Base><Blog /></Base>} />
          <Route path='/blog/:id' element={<Base><BlogDetails /></Base>} />

          {/* Auth Pages */}
          <Route path='/login' element={<Login />} />
          <Route path='/choose' element={<RoleSelection />} />
          <Route path='/register' element={<Register />} />

          {/* Admin Pages */}
          <Route path='/admin/login' element={<AdminLogin />} />
          <Route path='/admin' element={<SuperAdmin />} />
          <Route path='/admin/bills' element={<AdminBillManagement />} />
          <Route path='/admin/fields' element={<AdminFieldDragDrop />} />
          <Route path='/admin/roznamacha-fields' element={<AdminRozNamachaFields />} />
          <Route path='/admin/recoveries' element={<AdminRecoveryManagement />} />
          <Route path='/admin/expenses' element={<AdminExpenseManagement />} />
          <Route path='/admin/payment-methods' element={<AdminPaymentMethods />} />
          <Route path='/admin/team-members' element={<AdminTeamMembers />} />
          <Route path='/admin/recognitions' element={<AdminRecognitions />} />
          <Route path='/admin/blogs' element={<AdminBlogs />} />
          <Route path='/admin/bill-header-image' element={<AdminBillHeaderImage />} />
          <Route path='/admin/company-dashboard-management' element={<AdminCompanyDashboardManagement />} />

          {/* Company Pages */}
          <Route path='/company/login' element={<CompanyLogin />} />
          <Route path='/company/dashboard' element={<CompanyDashboard />} />
          <Route path='/company/dashboard-part2' element={<CompanyDashboardPart2 />} />
          <Route path='/company/dashboard-en' element={<EnglishCompanyDashboard />} />

          {/* Bill Pages */}
          <Route path='/bill/view/:billId' element={<BillView />} />
          <Route path='/bill/create' element={<CreateBill />} />
          <Route path='/bill/create-part2' element={<CreateBillPart2 />} />

          {/* Sale Pages */}
          <Route path='/sale/create' element={<CreateSale />} />
          <Route path='/sale/view/:saleId' element={<SaleView />} />
          <Route path='/general-sale' element={<GeneralSale />} />

          {/* Recovery Pages */}
          <Route path='/recovery/create' element={<CreateRecovery />} />
          <Route path='/recovery/view/:recoveryId' element={<RecoveryView />} />
          <Route path='/recovery/records' element={<RecoveryRecords />} />

          {/* Roz Namacha Pages */}
          <Route path='/roz-namacha' element={<SettledBill />} />
          <Route path='/roznamacha' element={<RozNamacha />} />

          {/* Ledger Pages */}
          <Route path='/receivable-khata' element={<Base><ReceivableKhata /></Base>} />
          <Route path='/payable-khata' element={<Base><PayableKhata /></Base>} />
          <Route path='/expense-fields-ledger' element={<Base><ExpenseFieldsLedger /></Base>} />
          <Route path='/expense-fields-details' element={<Base><ExpenseFieldsDetails /></Base>} />
          <Route path='/stock-report' element={<Base><StockReport /></Base>} />
          <Route path='/profit-loss-account' element={<Base><ProfitLossAccount /></Base>} />
          <Route path='/bank-khata' element={<Base><BankKhata /></Base>} />
          <Route path='/expense-ledger' element={<Base><ExpenseLedger /></Base>} />

          {/* CompanyDashboardPart2 Standalone Pages with P2 suffix */}
          <Route path='/bank-khata-p2' element={<BankKhataP2Wrapper />} />
          <Route path='/expense-ledger-p2' element={<ExpenseLedgerP2Wrapper />} />
          <Route path='/receivable-khata-p2' element={<ReceivableKhataP2Wrapper />} />
          <Route path='/payable-khata-p2' element={<PayableKhataP2Wrapper />} />
          <Route path='/profit-loss-p2' element={<ProfitLossAccountP2Wrapper />} />
          <Route path='/receipt-management-p2' element={<ReceiptManagementP2Wrapper />} />
          <Route path='/roz-namacha-p2' element={<SettledBill />} />
          <Route path='/roznamacha-p2' element={<RozNamachaP2Wrapper />} />
          <Route path='/customer-khata-p2' element={<CustomerKhataP2Wrapper />} />
          <Route path='/supplier-khata-p2' element={<SupplierKhataP2Wrapper />} />
          <Route path='/akhrajat-book-p2' element={<AkhrajatBookP2Wrapper />} />
          <Route path='/amdani-book-p2' element={<AmdaniBookP2Wrapper />} />
          <Route path='/recovery-details-p2' element={<RecoveryDetailsP2Wrapper />} />

          {/* User Management */}
          <Route path='/user-manage' element={<UserManage />} />

          {/* 404 Route */}
          <Route path='*' element={<PageNotFound404 />} />

        </Routes>

      </BrowserRouter>
    </>
  );
}

export default App;
